(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headerr"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.chReady) return;
      root.dataset.chReady = 'true';

      var drawer = root.querySelector('[data-ch-drawer]');
      var overlay = root.querySelector('[data-ch-overlay]');
      var openBtn = root.querySelector('[data-ch-open]');
      var searchBtn = root.querySelector('[data-ch-search-toggle]');
      var searchPanel = root.querySelector('[data-ch-search]');

      function openDrawer() {
        if (!drawer) return;
        drawer.hidden = false;
        overlay.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        var first = drawer.querySelector('button, a');
        if (first) first.focus();
      }

      function closeDrawer() {
        if (!drawer || drawer.hidden) return;
        drawer.classList.remove('is-open');
        overlay.hidden = true;
        openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        setTimeout(function () { drawer.hidden = true; }, 250);
        openBtn.focus();
      }

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      root.querySelectorAll('[data-ch-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });

      if (searchBtn && searchPanel) {
        searchBtn.addEventListener('click', function () {
          var willOpen = searchPanel.hidden;
          searchPanel.hidden = !willOpen;
          searchBtn.setAttribute('aria-expanded', String(willOpen));
          if (willOpen) {
            var input = searchPanel.querySelector('input[type="search"]');
            if (input) input.focus();
          }
        });
      }

      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (drawer && !drawer.hidden) closeDrawer();
        if (searchPanel && !searchPanel.hidden) {
          searchPanel.hidden = true;
          searchBtn.setAttribute('aria-expanded', 'false');
          searchBtn.focus();
        }
      });

      root._chOpen = openDrawer;
      root._chClose = closeDrawer;
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-custom-header]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      document.documentElement.style.overflow = '';
      initAll(e.target);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-custom-header]');
      if (root && root._chOpen && e.target.closest('[data-ch-drawer]')) root._chOpen();
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest('[data-custom-header]');
      if (root && root._chClose) root._chClose();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landerr"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__smrCarouselBound) return;
    window.__smrCarouselBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.smr-carousel__arrow');
      if (!btn) return;
      var root = btn.closest('.smr-carousel');
      var track = root && root.querySelector('.smr-carousel__track');
      if (!track) return;
      var slide = track.querySelector('.smr-carousel__slide');
      var step = slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      var dir = parseInt(btn.getAttribute('data-smr-dir'), 10) || 1;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (dir > 0 && track.scrollLeft >= max) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && track.scrollLeft <= 2) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains('smr-carousel__slide')) return;
      var track = el.closest('.smr-carousel__track');
      if (track) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metabalae"] && !Shopify.designMode) return;
  try {
    
  class MblCountdown extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;

      var minutes = parseInt(this.dataset.minutes, 10);
      if (isNaN(minutes) || minutes < 1) minutes = 7;

      this.total = minutes * 60;
      this.remaining = this.total;
      this.paint();

      this.timer = setInterval(
        function () {
          this.remaining -= 1;
          if (this.remaining < 0) this.remaining = this.total;
          this.paint();
        }.bind(this),
        1000
      );
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
    }

    paint() {
      var m = Math.floor(this.remaining / 60);
      var sec = this.remaining % 60;
      this.textContent = ('0' + m).slice(-2) + ' : ' + ('0' + sec).slice(-2);
    }
  }

  if (!customElements.get('mbl-countdown')) {
    customElements.define('mbl-countdown', MblCountdown);
  }

  } catch(e) { console.error(e); }
})();
})();
